// src/utils/budgetUtils.js

import { format } from 'date-fns';

/**
 * Format date to display format
 * @param {Date|string} date - Date to format
 * @returns {string} Formatted date string
 */
export const formatDate = (date) => {
  if (!date) return 'N/A';
  
  try {
    return format(new Date(date), 'MMM d, yyyy');
  } catch {
    return 'Invalid date';
  }
};

/**
 * Format number as USD currency
 * @param {number} amount - Amount to format
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount) => {
  if (amount === undefined || amount === null) return '$0.00';
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);
};

/**
 * Calculate budget summary from project data
 * @param {Object} project - Project object
 * @returns {Object} Budget summary
 */
export const calculateBudgetSummary = (project) => {
  if (!project || !project.budget) {
    return {
      totalBudget: 0,
      totalExpenses: 0,
      totalIncome: 0,
      remaining: 0,
      transactions: []
    };
  }
  
  const { budget, transactions = [] } = project;
  
  const totalBudget = budget.amount || 0;
  const totalExpenses = transactions
    .filter(t => t.type === 'expense')
    .reduce((total, t) => total + (t.amount || 0), 0);
  const totalIncome = transactions
    .filter(t => t.type === 'income')
    .reduce((total, t) => total + (t.amount || 0), 0);
  const remaining = totalBudget - totalExpenses + totalIncome;
  
  return {
    totalBudget,
    totalExpenses,
    totalIncome,
    remaining,
    transactions
  };
};